import React, { useState, useEffect } from 'react';
import { COUNTDOWN_DURATION } from '../../utils/constants';

const CountdownTimer = ({ onComplete }) => {
  const [count, setCount] = useState(COUNTDOWN_DURATION);

  useEffect(() => {
    if (count === 0) {
      onComplete();
      return;
    }

    const timer = setTimeout(() => {
      setCount(count - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [count, onComplete]);

  return (
    <div className="fixed inset-0 bg-white/95 backdrop-blur-sm flex items-center justify-center z-50">
      {/* Background elements */}
      <div className="absolute inset-0 forensic-grid-overlay opacity-20" />
      <div className="forensic-spine" />
      <div className="forensic-corner-tl" />

      {/* Countdown content */}
      <div className="text-center relative z-10">
        {/* Main number */}
        <div className="relative">
          <div className="forensic-countdown animate-bounce">
            {count}
          </div>
          {/* Ring around number */}
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <div className="w-48 h-48 border-4 border-[#0e734b]/20 rounded-sharp" />
          </div>
        </div>

        {/* Status text */}
        <p className="text-2xl text-[#1A1A1A] font-bold tracking-[0.15em] uppercase mt-4">
          Get Ready
        </p>
        <p className="text-sm text-[#4A5550] tracking-[0.2em] uppercase mt-2">
          استعد للتصوير
        </p>

        {/* Progress dots */}
        <div className="mt-8 flex justify-center gap-3">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="w-3 h-3 bg-[#0e734b] rounded-sharp animate-pulse"
              style={{ animationDelay: `${i * 0.2}s` }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CountdownTimer;
